import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df0e6997faac0c/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8df0e6997faac0c/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8df0e6997faac0c/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df0e6997faac0c/node_modules/next/dist/client/link.js");
